import { useSelector } from 'react-redux'
import brandSelector from '../redux/selectors/brandSelector'

export const useCurrentBrand = () => {
    const brand = useSelector(brandSelector)
    return brand
}
